import { makeStyles } from '@material-ui/core/styles'
import { BREAKPOINTS, COLORS, FONTS, WIDTH_DIMENSIONS } from '../constants'
export const styles = makeStyles(theme => ({
  section: {
    paddingBottom: 60,
    [`& nav.MuiBreadcrumbs-root`]: {
      marginBottom: -10,
      [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
        marginBottom: 20,
      },
    },
    [`& li.MuiBreadcrumbs-li a`]: {
      fontSize: '14px !important',
      fontWeight: 300,
      color: COLORS.black,
      letterSpacing: '0.38px',
      lineHeight: '15px',
      cursor: 'pointer',
      fontFamily: 'Graphik Light',
    },
    [`& li.MuiBreadcrumbs-separator`]: {
      fontSize: '14px !important',
      fontWeight: 300,
      letterSpacing: '0.38px',
      lineHeight: '15px',
      fontFamily: 'Graphik Light',
      color: COLORS.black,
      marginTop: 5,
    },
    [`& li.MuiBreadcrumbs-li p`]: {
      height: 27.43,
      fontSize: '14px !important',
      fontWeight: 300,
      letterSpacing: '0.38px',
      lineHeight: '31px',
      fontFamily: 'Graphik Light',
      color: COLORS.black,
    },
  },
  TopTitle: {
    paddingTop: 30,
    textAlign: 'center',
  },
  firstRow: {
    display: 'flex',
    justifyContent: 'space-around',
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      flexDirection: 'column',
      justifyContent: 'flex-start',
      maxWidth: 600,
      margin: 'auto',
    },
    [`@media (max-width: ${BREAKPOINTS.xmd}px)`]: {
      maxWidth: 375,
    },
  },
  secondRow: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 40,
    paddingBottom: 50,
    flexWrap: 'wrap',
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      paddingTop: 0,
      paddingBottom: 30,
      flexDirection: 'column',
      maxWidth: 600,
      margin: 'auto',
    },
    [`@media (max-width: ${BREAKPOINTS.xmd}px)`]: {
      maxWidth: 375,
    },
  },
  buttonStyles: {
    fontFamily: FONTS.Graphik.GraphikMedium,
    fontSize: '0.75rem',
    maxWidth: 500,
    marginBottom: 50,
    borderRadius: '2.5rem',
    background: '#E33D40',
    border: 'none',
    '& > img': {
      filter: 'invert(1)',
    },
  },
  joinButton: {
    fontFamily: FONTS.Graphik.GraphikMedium,
    fontSize: '0.75rem',
    maxWidth: 343,
    marginBottom: 50,
    borderRadius: '2.5rem',
    background: '#E33D40',
    border: 'none',
    '& > img': {
      filter: 'invert(1)',
    },
  },
  howItWordsButton: {
    fontFamily: FONTS.Graphik.GraphikMedium,
    fontSize: '0.75rem',
    maxWidth: 343,
    borderRadius: '2.5rem',
    // background: '#E33D40',
    marginBottom: '2rem',
    border: 'none',
    '& > img': {
      filter: 'invert(1)',
    },
  },
  centerText: {
    textAlign: 'center',
    marginTop: '5rem',
  },
  gridItem: {
    textAlign: 'center',
    width: '100%',
  },
  videoSectionTitle: {
    marginBottom: 20,
  },
  videoSectionContent: {
    lineHeight: '23px',
  },
  circle2: {
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      marginLeft: 200,
    },
    [`@media (max-width: ${BREAKPOINTS.xmd}px)`]: {
      marginLeft: 77,
    },
  },
  circle4: {
    [`@media (max-width: ${BREAKPOINTS.lg}px)`]: {
      marginLeft: 200,
    },
    [`@media (max-width: ${BREAKPOINTS.xmd}px)`]: {
      marginLeft: 87,
    },
  },
  joinCircle: {
    width: '100%',
    maxWidth: 450,
    textAlign: 'center',
  },
  flexOrder: {
    display: 'flex',
    flexDirection: 'column',
  },
  brandsListStyle: {
    paddingTop: 100,
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {},
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      paddingTop: 45,
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      paddingTop: 45,
    },
  },
  mobileBackgroundStyle: {
    width: '100%',
    margin: '0 auto',
    maxWidth: WIDTH_DIMENSIONS.max,
    padding: '40px 0 154px',
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      padding: '40px 1% 154px',
    },
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      backgroundColor: COLORS.white,
      padding: '0px 0px',
      width: '95%',
    },
  },
  brandsListSection: {
    position: 'relative',
    [`@media (min-width: ${BREAKPOINTS.xl}px)`]: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  brandsListTitle: {
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      width: '100%',
      textAlign: 'center',
      display: 'block',
      // margin: '0 auto 30px 20px',
    },
    [`@media (min-width: ${BREAKPOINTS.xl}px)`]: {
      width: '30%',
      display: 'block',
      textAlign: 'right',
      margin: '0 auto 30px 10px',
    },
  },
  brandsHeading: {
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      textAlign: 'center',
      fontSize: '36px',
      lineHeight: '40px',
    },
  },
  subtitleBrandsSentence: {
    fontSize: '24px',
    lineHeight: '34px',
    letterSpacing: 'normal',
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      textAlign: 'center',
      fontSize: '18px',
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      width: '93%',
    },
  },
  addChirpyestButtonStyle: {
    position: 'absolute',
    bottom: -95,
    right: '5%',
    width: '100%',
    [`@media (min-width: ${BREAKPOINTS.lg}px)`]: {
      position: 'static',
      display: 'block',
      marginLeft: 'auto',
    },
    [`@media (max-width: ${BREAKPOINTS.mdd}px)`]: {
      right: 0,
      transform: 'translate(-52%, -50%)',
      left: '50%',
      width: '30.6%',
      bottom: -107,
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      right: 0,
      transform: 'translate(-50%, -50%)',
      left: '50%',
      width: '90%',
      bottom: -107,
    },
  },
  brandsListContainer: {
    width: '100%',
    [`@media (min-width: ${BREAKPOINTS.xl}px)`]: {
      width: '65%',
    },
  },
  allBrands: {
    borderRadius: '4rem',
  },
  trendingContainer3: {
    width: '100%',
    paddingTop: 25,
    overflow: 'hidden',
    position: 'relative',
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      width: '90%',
      margin: '0 auto',
      // paddingTop: 80,
    },
  },
  CHRbArrowButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    [`@media (max-width: ${BREAKPOINTS.md}px)`]: {
      width: '90%',
      margin: '0 auto',
    },
  },
  tabletMode: {
    ['& > .MuiGrid-container']: {
      overflow: 'auto',
      scrollbarWidth: 'none',
      MsOverflowStyle: 'none',
    },
    ['& > .MuiGrid-container::-webkit-scrollbar']: {
      display: 'none',
    },
  },
  trendingContainer: {
    width: '100%',
    paddingTop: 100,
    overflow: 'hidden',
    position: 'relative',
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      width: '90%',
      margin: '0 auto',
      paddingTop: 50,
    },
    [`@media (max-width: ${BREAKPOINTS.sm}px)`]: {
      paddingTop: 50,
    },
  },
  trendingContainer2: {
    width: '100%',
    overflow: 'hidden',
    position: 'relative',
    [`@media (min-width: ${BREAKPOINTS.md}px)`]: {
      // width: '90%',
      margin: '0 auto',
      // paddingTop: 80,
    },
  },
  topProductsContainer: {
    display: 'flex',
    ['& > div:first-child']: {
      marginRight: 13,
      ['& > button:last-child img']: {
        marginLeft: '3px !important',
        marginRight: '6px !important',
      },
    },
    ['& > div:last-child']: {
      marginLeft: 14,
      ['& > button:first-child img']: {
        marginLeft: '10px !important',
        marginRight: '5px !important',
      },
    },
  },
  arrowMaxHeight: {
    minWidth: 70,
    minHeight: 222,
    maxHeight: 222,
    display: 'flex',
    alignItems: 'center',
  },
}))
